import React  from 'react';

function App(props) {  
  return (
    <div className="contents-container">
        Plan
    </div>
  );
}

export default App;
